import cloneDeep from 'lodash.clonedeep';

export const initialState = {
    agreementsGroupByType: [],
    submitted: false
};

function transferReducer(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_TRANSFER_DATA': {
            const newState = {
                ...state,
                ...action.payload,
                submitted: false
            };
            return newState;
        }
        case 'UPDATE_TRANSFER_AGREEMENTS': {
            const { groupIndex, agreementIndex } = action.payload;
            const clonedAgreementsGroupByType = cloneDeep(state.agreementsGroupByType);
            clonedAgreementsGroupByType[groupIndex].agreements[agreementIndex].isTransfer = !clonedAgreementsGroupByType[groupIndex].agreements[agreementIndex].isTransfer

            const newState = {
                ...state,
                agreementsGroupByType: clonedAgreementsGroupByType,
            };
            return newState;
        }
        case 'UPDATE_SUBMITTED_STATUS': {
            const newState = {
                ...state,
                submitted: true
            };
            return newState;
        }
        default:
            return state;
    }
}

export default transferReducer;
